import { makeStyles } from "@material-ui/core";
import React from "react";
import Styles from "./index.module.scss";

import { convertNumberToPersian } from "../../../method/convertDigitToEnglish";


let useStyles = makeStyles((theme) => ({
  tableParent: {
    width: "100%",
    paddingBottom: 15,
    overflow: 'auto',
  },
  table: {
    backgroundColor: "#f2f2f2",
    width: "100%",
    "& tr": {
      "& :nth-child(odd)": {
        backgroundColor: "red",
      },
    },
  },
  modal: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  paper: {
    width: "60%",
    backgroundColor: theme.palette.background.paper,
    borderRadius: 8,
    border: 0,
    outline: 0,
    padding: theme.spacing(2, 4, 3),
    position: "relative",
    paddingTop: 40,
    [theme.breakpoints.down("1000")]: {
      width: "100%",
    },
  },
}));



const Index = () => {

  const classes = useStyles();
  const columns = [
    {
      key: 1,
      id: "title",
      label: "عنوان",
      minWidth: 120,
      align: "center",
    },
    {
      id: "fullName",
      label: "نام و نام خانوادگی",
      minWidth: 190,
      align: "left",
      format: (value) => convertNumberToPersian(value),
    },

  ];


  let state = [
    {
      title: "رئیس هیئت مدیره ",
      fullName: "محمدعلی شریفی نیا "
    },
    {
      title: "نایب رئیس هیئت مدیره ",
      fullName: "مهدی خلیلی "
    },
    {
      title: "عضو هیئت مدیره ",
      fullName: "رضا حاجی محمدخانی "
    },

  ]

  return (
    <>
      <div className={`${classes.tableParent} table-responsive`}>
        <table className={Styles.table} id="listingTable">
          <thead>
            <tr>
              <th>ردیف</th>
              {columns.map((itm, ind) => (
                <th style={{ minWidth: itm.minWidth }} key={ind}>{itm.label}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {state
              .map((itm, ind) => (
                <tr key={ind}>
                  <td>
                    {convertNumberToPersian(ind + 1)}
                  </td>
                  <td>{itm.title}</td>
                  <td>{itm.fullName}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </>
  );
};

export default Index;
